
import { AuthService } from '../_services/auth.service';
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router ,ActivatedRoute} from "@angular/router";

@Injectable()
export class GuardianShowGuard {

    constructor(
        private router: Router,
        private authService: AuthService) { }
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): boolean {
        let gatePass = this.authService.gatePass.getValue()
        let authId=gatePass.user_id
        let userId = +route.paramMap.get('server_user_id')

        if((userId==authId)|| gatePass.is_role_admin){
            return true
        }else{
            this.router.navigate(['/notfound'])
            return false
        }
    }
}
